<template>
  <v-card flat>
    <ConvertLanguageComponent style="display: none" />
    <v-card class="pa-5">
      <div class="d-flex" style="justify-content: space-between;">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="black"
          slider-color="#EAA413"
        >
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
        <div>
          <v-btn color="transparent" class="pa-0" depressed @click="close()"
            ><v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <v-tabs-items v-model="tab" class="my-6">
        <v-tab-item>
          <v-card flat>
            <v-row class="d-flex justify-space-around mx-2">
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'en' }"
                ><v-btn
                  color="transparent"
                  depressed
                  x-large
                  @click="changeLanguage('en','English')"
                  class="lang-btn" width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    English
                  </span>
                </v-btn>
              </v-col>
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'es' }">
                <v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('es','Spanish')"
                  width="100%"
                >
                  <div class="px-1 py-3">
                    <div class="">
                      <span style="text-transform: none">Spanish</span>
                    </div>
                    <div>
                      <span class="text_heading_ttb"> (Latinoamérica)</span>
                    </div>
                  </div>
                </v-btn>
              </v-col>

              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'pt' }"
                ><v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('pt','Portuguese')"
                  width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    Portuguese</span
                  >
                </v-btn>
              </v-col>
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'de' }"
                ><v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('de','German')"
                  width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    German
                  </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-space-around mx-2 my-2">
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'cs' }">
                <v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('cs','Czech')"
                  width="100%"
                >
                  <div>
                    <div class="">
                      <span class="px-1 py-3" style="text-transform: none">Czech</span>
                    </div>
                  </div>
                </v-btn>
              </v-col>

              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'ja' }"
                ><v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('ja','Japanese')"
                  width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    Japanese
                  </span>
                </v-btn>
              </v-col>
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'fr' }"
                ><v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('fr','French')"
                  width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    French
                  </span>
                </v-btn>
              </v-col>
              <v-col class="lang-col" cols="12" sm="3" md="3" :class="{ 'highlight': selectedLanguage === 'no' }"
                ><v-btn
                  color="transparent"
                  depressed
                  class="lang-btn"
                  x-large
                  @click="changeLanguage('no','Norwegian')"
                  width="100%"
                >
                  <span class="px-1 py-3" style="text-transform: none">
                    Norwegian
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-row class="d-flex justify-space-around">
              <v-col cols="6" sm="3" md="3">
                <v-btn color="transparent" depressed class="d-flex">
                  <div>
                    <div class="d-flex justify-start">
                      <span class="style_text_h">USD - $</span>
                    </div>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    ARS - ARS$
                  </span>
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    AUD - A$</span
                  >
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    MXN - Mex$
                  </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-space-around">
              <v-col cols="6" sm="3" md="3">
                <v-btn color="transparent" depressed class="d-flex">
                  <div>
                    <div class="d-flex justify-start">
                      <span class="style_text_h">USD - $</span>
                    </div>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    ARS - ARS$
                  </span>
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    AUD - A$</span
                  >
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" md="3"
                ><v-btn color="transparent" depressed class="mx-3" x-large>
                  <span class="px-1 py-3" style="text-transform: none">
                    MXN - Mex$
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <v-card-text class="mt-3 mb-3">
      <v-window v-model="tabs">
        <v-window-item value="one">
          <v-row class="d-flex justify-space-around">
            <v-col cols="6" sm="3" md="3">
              <div>
                <span class="style_text_h">Español</span> <br /><span
                  class="text_heading_ttb"
                >
                  (Latinoamérica)</span
                >
              </div>
            </v-col>

            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  English
                </span>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  Portuguese</span
                >
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  Deutsch
                </span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around">
            <v-col cols="6" sm="3" md="3">
              <div>
                <span class="style_text_h">Español</span> <br /><span
                  class="text_heading_ttb"
                >
                  (Latinoamérica)</span
                >
              </div>
            </v-col>

            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  English
                </span>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  Portuguese</span
                >
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="mx-3" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  Deutsch
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item value="two">
          <v-row class="d-flex justify-space-around">
            <v-col cols="6" sm="3" md="3"
              ><v-btn
                color="transparent"
                variant="flat"
                class="pl-0 pr-0"
                x-large
              >
                <span class="px-1 py-3" style="text-transform: none"
                  >USD - $
                </span>
              </v-btn>
            </v-col>

            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  ARS - ARS$
                </span>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  AUD - A$</span
                >
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn
                color="transparent"
                variant="flat"
                class="pl-0 pr-0"
                x-large
              >
                <span class="px-1 py-3" style="text-transform: none">
                  MXN - Mex$</span
                >
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around">
            <v-col cols="6" sm="3" md="3"
              ><v-btn
                color="transparent"
                variant="flat"
                class="pl-0 pr-0"
                x-large
              >
                <span class="px-1 py-3" style="text-transform: none"
                  >USD - $
                </span>
              </v-btn>
            </v-col>

            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  ARS - ARS$
                </span>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  AUD - A$</span
                >
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="3"
              ><v-btn color="transparent" variant="flat" class="" x-large>
                <span class="px-1 py-3" style="text-transform: none">
                  MXN - Mex$</span
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
    </v-card-text> -->
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import ConvertLanguageComponent from "../language/converlanguage.component.vue";

export default defineComponent({
  name: "LanguageComponent",
  components: {
    ConvertLanguageComponent,
  },
  props: ["languagecomponent"],

  data() {
    return {
      tab: null,
      selectedLanguage: 'en',
      items: ["Language"],
      text: "Lorem ipsum dolor sit amet, minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      german: {
        code: "en|de",
        title: "German",
      },
    };
  },
  mounted(){
    switch(localStorage.getItem("LanguageName")){
      case "English":
        this.selectedLanguage = "en";
        break;
        case "Spanish":
        this.selectedLanguage = "es";
        break;
        case "Portuguese":
        this.selectedLanguage = "pt";
        break;
        case "German":
        this.selectedLanguage = "de";
        break;
        case "Czech":
        this.selectedLanguage = "cs";
        break;
        case "Japanese":
        this.selectedLanguage = "ja";
        break;
        case "French":
        this.selectedLanguage = "fr";
        break;
        case "Norwegian":
        this.selectedLanguage = "no";
        break;
        default:
          this.selectedLanguage = "en";
    }
  },
  methods: {
    changeLanguage(lang,name) {
      localStorage.setItem("LanguageName",name)
      this.selectedLanguage = lang;
      this.$emit('languageSelected', lang,name);
      if (lang == ""){
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|en",
            title: "English",
          },
        ]);
      } else if (lang == "en") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|en",
            title: "English",
          },
        ]);
      } else if (lang == "es") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|es",
            title: "Spanish",
          },
        ]);
      } else if (lang == "pt") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|pt",
            title: "Portuguese",
          },
        ]);
      } else if (lang == "de") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|de",
            title: "German",
          },
        ]);
      } else if (lang == "cs") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|cs",
            title: "Czech",
          },
        ]);
      } else if (lang == "ja") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|ja",
            title: "Japanese",
          },
        ]);
      } else if (lang == "fr") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|fr",
            title: "French",
          },
        ]);
      } else if (lang == "no") {
        this.$store.dispatch("changeLanguage", [
          {
            code: "en|no",
            title: "Norwegian",
          },
        ]);
      }
      // if (window.google && window.google.translate) {
      //   const frame = document.querySelector('.goog-te-menu-frame');
      //   if (frame) {
      //     const select = frame.contentDocument.querySelector('.goog-te-combo');
      //     if (select) {
      //       select.value = lang;
      //       select.dispatchEvent(new Event('change'));
      //     }
      //   }
      // }
      const waitForGoogleTranslate = () => {
        const combo = document.querySelector(".goog-te-combo");
        if (combo) {
          combo.value = lang;
          combo.dispatchEvent(new Event("change"));
        } else {
          // Try again shortly
          setTimeout(waitForGoogleTranslate, 200);
        }
      };
      waitForGoogleTranslate();
      // setTimeout(() => {
      //   document.querySelector(".flag").click();
      // }, 500);
    },
    close() {
      this.$emit("close");
    },
  },
});
</script>

<style scoped>
.v-btn.v-btn--density-default {
  height: auto;
}
.style_text_h {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-transform: none;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.tabs_slider {
  color: #eaa413;

  font-weight: 800;
  font-size: 16px;
  line-height: 21px;
  border-bottom: 2px solid #e1e4e7;
}
.feild {
  background-color: #f6f8fc;
  border: 1px solid #f2f3f9;
  border-radius: 6px;
  height: 50px;
}
.text_heading_ttb {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  text-transform: none;
  color: rgba(8, 8, 22, 0.38);
}
.btn_space {
  white-space: normal;
  width: 100px;
}
.highlight {
  color: rgb(30, 0, 255);
  border: 3px solid rgb(30, 0, 255) !important;
}
@media(max-width:768px){
  .lang-col{
  max-width:200px; margin:4px auto; padding:0;
}
.lang-btn{
  margin:auto; width:100%;
}
}
</style>
